export default "__VITE_ASSET__DGMrp66v__"